import { Button } from "@headlessui/react";
import { CSSProperties } from "react";

export const PrimaryButton = ({
  children,
  className,
  onClick,
  otherProps,
  disabled,
  style,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: Function;
  otherProps?: any;
  style?: CSSProperties;
  disabled?: boolean;
}) => (
  <>
    <Button
      className={`py-2 px-2 sm:px-3 md:px-8 rounded bg-blue-700 text-white data-[hover]:bg-blend-darken data-[active]:bg-blend-darken ${className}`}
      onClick={onClick}
      style={style}
      disabled={disabled}
      {...otherProps}
    >
      {children}
    </Button>
  </>
);
